import { useEffect, useRef } from 'react'

const SITE_KEY = import.meta.env.VITE_TURNSTILE_SITE_KEY
const SCRIPT_URL = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit'

export default function Turnstile({ onToken, onExpire }) {
  const containerRef = useRef(null)
  const widgetIdRef = useRef(null)

  useEffect(() => {
    if (!SITE_KEY) return

    function renderWidget() {
      if (!containerRef.current || widgetIdRef.current != null) return
      widgetIdRef.current = window.turnstile.render(containerRef.current, {
        sitekey: SITE_KEY,
        callback: onToken,
        'expired-callback': onExpire,
        'error-callback': onExpire,
        theme: 'auto',
      })
    }

    // Load script if not already present
    if (!document.querySelector('script[src*="challenges.cloudflare.com/turnstile"]')) {
      const script = document.createElement('script')
      script.src = SCRIPT_URL
      script.async = true
      script.onload = renderWidget
      document.head.appendChild(script)
    } else if (window.turnstile) {
      renderWidget()
    } else {
      // Script tag exists but hasn't loaded yet — poll briefly
      const interval = setInterval(() => {
        if (window.turnstile) { clearInterval(interval); renderWidget() }
      }, 100)
      return () => clearInterval(interval)
    }

    return () => {
      if (widgetIdRef.current != null && window.turnstile) {
        window.turnstile.remove(widgetIdRef.current)
        widgetIdRef.current = null
      }
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  if (!SITE_KEY) return null

  return <div ref={containerRef} style={{ marginTop: 12, marginBottom: 4 }} />
}
